import angular from 'angular';

import angularAnimate from 'angular-animate';

import angularSanitize from 'angular-sanitize';

import angularFilter from 'angular-filter';

import angularUIRouter from '@uirouter/angularjs';

import geneseNotification from '@advise/genese-notification';

export default angular.module('advise', [
	angularAnimate,
	angularSanitize,
	angularFilter,
	angularUIRouter,
	geneseNotification,
	'ngNotify'
]);
